import { equals } from '@execonline-inc/collections';
import { emptyFragment, StarIcon, Typography } from '@execonline-inc/execonline-ui';
import { when } from '@execonline-inc/maybe-adapter';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { T } from '../../../Translations';

interface Props {
  saveState: Maybe<string>;
}

function PublishedToaster({ saveState }: Props) {
  return saveState
    .andThen((value) => when(equals(value, 'published'), 'published'))
    .map(() => (
      <div className="w-full rounded-t-lg flex items-center py-1.5 px-8 border-b-1 bg-[#227AFF1A] border-b-[#227AFF4D]">
        <StarIcon color="light-blue" />
        <Typography variant="bodyMedium" fontWeight="medium">
          <T kind="Published just now" />
        </Typography>
      </div>
    ))
    .getOrElse(emptyFragment);
}

export default observer(PublishedToaster);
